import { render, staticRenderFns } from "./AuthorBoard.vue?vue&type=template&id=c247281c&"
import script from "./AuthorBoard.vue?vue&type=script&lang=js&"
export * from "./AuthorBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports